import React from "react";
import { Helmet } from "react-helmet";


import ji from './images/javai.png';
import pi from './images/python.png';
import js from './images/jsi.png';

import cs from './images/csi.png';
import ci from './images/ci.png';
import phi from './images/phi.png';
import cp from './images/cpi.png';

function Allpro() {

  return (



    <div >

      <Helmet>

        <title>Programmings Language Tutorials and Difference Between Programming Language</title>
        <meta name="description" content="Programming language tutorial for begineers tutorial for begineers.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,python tutorial for beginners in deeply knowledge With Deeply" />
        <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Difference Between Java and Python,Difference between program and code,java tutorial for begineers,python tutorial for begineers,Python tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and python tutorial,code,exampler,java vs python,java vs Python" />
        <link rel="canonical" href="https://www.codeexampler.com/programming-language-to-learn" />
      </Helmet>


      <div className="flex flex-col bg-[#ff0000] " style={{ marginTop: "-25px" }}>
        <div className=" text-center mt-10" style={{ color: '#07004e' }}>

          <h1 className='text-4xl lg:text-6xl font-bold text-blue'>
            Choose what to Learn <span className='text-white'> Free </span>Coding
          </h1>
          <h1 className='text-lg lg:text-xl my-4 font-bold text-blue'>
            Start Learn <span className='text-white'> Free </span>  Popular Programming Languages
          </h1>
        </div>

        <div className='grid grid-cols-1 place-items-center sm:grid-cols-2 lg:grid-cols-3 gap-y-11 mb-10'>

          <a href="/python-variables" style={{ textDecoration: "none" }}> <div style={{ borderRadius: "2rem" }} class=" card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white">

            <img src={pi} className='lg:h-44  lg:w-44 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col ">
              <h5 class=" text-2xl lg:w-96  mb-2 text-center font-bold">Python </h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free Python
              </button>


            </div>
          </div></a>

          {/* Java */}

          <a href="/java-variables" style={{ textDecoration: "none" }}> <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white  ">

            <img src={ji} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col">
              <h5 class="text-2xl lg:w-96  mb-2 text-center pr-8 font-bold">Java</h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free Java
              </button>




            </div>
          </div>  </a>

          {/* Java */}


          {/* Js */}

          <a href="/javascript-variables" style={{ textDecoration: "none" }}>  <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white  ">

            <img src={js} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col">
              <h5 class=" text-2xl lg:w-96  mb-2 text-center  font-bold">Js</h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free JavaScript
              </button>




            </div>
          </div>  </a>

          {/* JS */}

          {/* C# */}

          <a href="/csharp-first-program" style={{ textDecoration: "none" }}>  <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white  ">


            <img src={cs} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col">
              <h5 class=" text-2xl lg:w-96  mb-2 text-center font-bold">C#</h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free C#
              </button>




            </div>
          </div>  </a>

          {/* C# */}

          {/* PHP */}

          <a href="/php-variables" style={{ textDecoration: "none" }}>  <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white ">

            <img src={phi} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col">
              <h5 class=" text-2xl lg:w-96  mb-2 text-center  font-bold">PHP</h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free PHP
              </button>




            </div>
          </div>  </a>

          {/* PHP */}

          {/* C */}

          <a href="/c-variable" style={{ textDecoration: "none" }}> <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white " >

            <img src={ci} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col">
              <h5 class=" text-2xl lg:w-96  mb-2 text-center  font-bold">C </h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free C
              </button>




            </div>
          </div></a>

          {/* C */}


          {/* C++ */}

          <a href="/cpp-variable" style={{ textDecoration: "none" }}> <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white">

            <img src={cp} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
            <div class="p-6 flex items-center flex-col">
              <h5 class=" text-2xl lg:w-96  mb-2 text-center  font-bold">C++ </h5>

              <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                Learn Free C++
              </button>



            </div>
          </div></a>
          {/* C++ */}
        </div>




        <div className="flex flex-col ">
          <h1 className='text-4xl lg:text-6xl text-blue font-bold ml-3 text-center my-6 '>
            Difference Between Programming Languages Tutorial
          </h1>
          <div className='grid grid-cols-1 place-items-center sm:grid-cols-2 lg:grid-cols-2 gap-y-11 mb-10'>
            <a href="/java-vs-python-basic" style={{ textDecoration: "none" }}> <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white">

              <img src={pi} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
              <div class="p-6 flex items-center flex-col">
                <h5 class=" text-2xl lg:w-96  mb-2 text-center font-bold">Java Vs Python</h5>

                <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                  Java Vs Python
                </button>




              </div>
            </div></a>

            <a href="/java-vs-csharp-basic" style={{ textDecoration: "none" }}> <div style={{ borderRadius: "2rem" }} class="rounded-3xl card h-72 lg:h-[346px] justify-center text-blue lg:w-80  bg-white max-w-sm w-72  cursor-pointer hover:scale-105 transition duration-300   mt-10 items-center flex flex-col shadow-white  " s>

              <img src={cs} className='lg:h-52  lg:w-52 h-28 mt-2 w-36' alt="asfd" />
              <div class="p-6 flex items-center flex-col">
                <h5 class=" text-2xl lg:w-96  mb-2 text-center  font-bold">Java Vs C#</h5>

                <button class="rounded-full h-12 w-48 text-xl bg-blue hover:bg-lightBlue text-white active:bg-blue-800 focus:outline-none focus:ring focus:ring-violet-300 ..." >
                  Java Vs C#
                </button>




              </div>
            </div> </a>



          </div>
        </div>


      </div>
    </div>





  )

}
export default Allpro;